import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import type { SpacePlayerSetupDto } from '@/types/dtos/player/response/av-sources.dto';
import { GET_AV_SOURCES_QUERY_KEY } from '@/state/queries/players/use-get-av-sources';
import { GET_SPACE_PLAYER_SETUP_QUERY_KEY } from '@/state/queries/players/use-get-space-player-setup';
import { GET_EVENT_QUERY_KEY } from '@/state/queries/events/use-get-event';

export type PatchSpacePlayerSetupParams = {
  spaceId: string;
  eventId?: string;
  playerSetupEnabled?: boolean;
  videoPlayerId?: string | null;
  audioPlayerId?: string | null;
};

export const usePatchSpacePlayerSetupMutation = () => {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: PatchSpacePlayerSetupParams) => {
      const token = await getToken();
      return patchSpacePlayerSetup(params, token ?? '');
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_SPACE_PLAYER_SETUP_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [GET_AV_SOURCES_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [GET_EVENT_QUERY_KEY] });
    },
  });
};

const patchSpacePlayerSetup = async (
  params: PatchSpacePlayerSetupParams,
  token: string,
): Promise<SpacePlayerSetupDto> => {
  const url = `${import.meta.env.VITE_API_URL}/player/space-setup`;
  return sendJSONRequest({ url, method: METHOD.PATCH, body: params, token });
};
